
// components
import updatePassword from './component/updatePassword.component.js'

export default angular
  .module('portalApp.updatePassword', [])
  .component('updatePassword', updatePassword)
  .name
